import api from "./axios";
import { NewsFeedItem, NewsPost, NewsPostRequest } from "../interfaces/News";

export async function getNewsFeed(): Promise<NewsFeedItem[]> {
  const { data } = await api.get("/News");
  return data;
}

export async function getNewsUnreadCount(): Promise<number> {
  const { data } = await api.get("/News/unread-count");
  return data.count;
}

export async function markNewsRead(id: number): Promise<void> {
  await api.post(`/News/${id}/read`);
}

export async function markAllNewsRead(): Promise<void> {
  await api.post("/News/read-all");
}

/** Lista de quem publica — inclui rascunho e expirado. */
export async function getNewsPosts(): Promise<NewsPost[]> {
  const { data } = await api.get("/News/admin");
  return data;
}

export async function createNewsPost(req: NewsPostRequest): Promise<NewsPost> {
  const { data } = await api.post("/News", req);
  return data;
}

export async function updateNewsPost(id: number, req: NewsPostRequest): Promise<NewsPost> {
  const { data } = await api.put(`/News/${id}`, req);
  return data;
}

export async function deleteNewsPost(id: number): Promise<void> {
  await api.delete(`/News/${id}`);
}
